import { render } from "./NavSidebarHOC.vue?vue&type=template&id=5420b467"
import script from "./NavSidebarHOC.vue?vue&type=script&lang=js"
export * from "./NavSidebarHOC.vue?vue&type=script&lang=js"
script.render = render

export default script